export enum SyncStatus {
    Synced = 0,
    Pending = 1,
    ConflictOrError = 2,
    Processing = 3,
}

export class environmentInfo {
    version?: string;
    domain?: string;
    clientIpAddress?: string;
}
